<template>
  <div>
    <div class="text-center padding-tb-lg">
      <div to="/featnet" style="color: #bfbfc3" @click="onClick">
        <span class="custom">多陪提供技术支持</span>
      </div>
    </div>
  </div>
</template>

<script>


import {Toast} from "vant";
import {getRegisterChannel} from "@/api/tech_support";
import {addTechView} from "@/api/page_view";

export default {
  name: 'foot',
  data () {
    return {
    }
  },
  methods: {
    onClick(){
      if(this.$store.state.shop.techSupportVersion===2 ){
        addTechView()
        this.toRegister()
      }else{
        this.$router.push('/featnet')
      }
    },
    toRegister(){
      Toast.loading({
        mask: true,
        message: '加载中'
      })
      getRegisterChannel().then(res=>{
        const data = res.data
        if(data.code===0 && data.data){
          let source = {
            channel: data.data,
            end: 'shop'
          }
          window.location.href = 'http://console.duopei.cc/register?code=' + window.btoa(JSON.stringify(source))
        }else{
          Toast.clear()
        }
      })
    }
  },
  mounted() {
    console.log(this.$store.state.shop.techSupportVersion)
  }
}
</script>

<style lang="less" scoped>


</style>
